<template>
  <hm-content title="">
    <div class="">
      <div class="table-panel flex flex-between">
        <el-button size="small" @click="addGroup" type="primary"
          >添词官方词库</el-button
        >
        <div>
          <el-input
            class="mr10"
            size="small"
            v-model="searchConditions.groupName"
            placeholder="请输入规则名称"
            clearable
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="table-wrapper">
        <el-table
          :data="groupList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="词库名称"
            prop="groupName"
          >
          </el-table-column>
          <el-table-column 
            header-align="center"
            align="center"
            prop="typeName"
            label="词库分类"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="编辑" placement="top">
                  <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                    <span class="hmicon icon-bianji blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="top"
                  style="color: #E50065"
                >
                  <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                    <span class="hmicon icon-shanchu blue"></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="groupListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import {getLoginUser, getUserName} from "@/utils/auth";
export default {
  components: {
  },
  data() {
    return {
      searchConditions: {},
      currentPage: 1,
      pageSize: 10,
      groupList: [],
      groupListTotal: 0,
      currentRow: {},
    };
  },
  computed: {

  },
  watch: {},
  created() {
    this.queryList();
  },
  mounted() {},
  methods: {
    addGroup() {
      this.$router.push({ name: "SysDictionaryAdd" });
    },
    async edit(row) {
      this.$router.push({
        name: "SysDictionaryEdit",
        query: {
          id: row.id
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchConditions = JSON.parse(JSON.stringify(this.searchConditions));
      
      Object.assign(params, searchConditions);
      const { result } = await this.$store.dispatch("sysDictionaryGroupInfoQueryPageList", params);
      const { records, total } = result;
      this.groupList = records;
      this.groupListTotal = total;
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("sysDictionaryGroupInfoRemoveByModel", {
          id: row.id
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
